import type { MemberChemistryBookingSlot } from '@/types';

export const normalizeMemberBookingSlots = (
  slots: MemberChemistryBookingSlot[],
) =>
  slots.filter(
    (slot) =>
      typeof slot.startTime === 'string' &&
      slot.startTime.trim() !== '' &&
      typeof slot.endTime === 'string' &&
      slot.endTime.trim() !== '',
  );
